import focusManager from "focus-manager";
import {ToggleScroll} from "@main/components/toggle-scroll";
    
/** Класс модального окна о студенте. */
class ModalAboutStudent {
    documentEl = document.body

    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} modal Элемент.
     */
    constructor(modal) {
        this.modal = modal;
        this.photo = this.modal.querySelector(".js-about-student-photo");
        this.name = this.modal.querySelector(".js-about-student-name");
        this.description = this.modal.querySelector(".js-about-student-text");
        
        this.bindEventListeners();
    }

    /**
     * Прослушиваем события.
     * 
     * @returns {void}
     */
    bindEventListeners() {
        document.addEventListener("click", (e) => {
            if (e.target.classList.contains("js-open-modal-about-student")) {
                this.showModal();

                const photoStudent = e.target.classList.contains("js-student-name") ?
                    e.target.previousElementSibling : e.target;

                const student = {
                    image: photoStudent,
                    imageSrc: photoStudent.getAttribute("src"),
                    card: e.target.parentElement,
                    name: e.target.parentElement.querySelector(".js-student-name"),
                    description: e.target.parentElement.querySelector(".js-student-description")
                }

                this.photo.src = student.imageSrc;
                this.name.innerHTML = student.name.textContent;
                this.description.innerHTML = student.description.innerHTML;
            }
        });
    }

    /**
     * Открытие модального окна.
     * 
     * @returns {void}
     */
    showModal = () => {    
        this.modal.classList.add("shown");
        ToggleScroll.disable(this.modal);
        focusManager.capture(this.modal);
    }
}
    
window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-modal[data-modal='student']")
        .forEach(el => new ModalAboutStudent(el));
});
